module.exports = __webpack_public_path__ + "img/beers.9cdd5870.png";